let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c5Sw3")).then(() => parcelRequire('d9zBr'));